import { Input } from './Input'

export const NumberInput = {
  baseStyle: {
    _placeholder: { color: 'product.text.dark.placeholder' },
    field: {
      color: 'product.text.dark.bodySolid',
    },
    _focus: {
      _invalid: {
        borderColor: 'product.state.solid.error',
      },
    },
  },
  variants: {
    outline: {
      field: Input.variants.outline.field,
      stepper: {
        border: 'none',
      },
      stepperGroup: {
        color: 'blueGray.500',
        top: '0',
      },
    },
  },
  sizes: Input.sizes,
}
